import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthStore} from "../store/useAuth.store";
import HomePage from "./public/Home";

const ProtectedHomePage = () => {
  const navigate = useNavigate();
  const user = useAuthStore(state => state.user);
  const authStatus = useAuthStore(state => state.authStatus);

  useEffect(() => {
    // Only redirect if user is authenticated and is the special user
    if (authStatus === "authenticated" && user) {
      const authorizedEmails = ["test01@googletest.com", "test01@gmailtest.com"];
      if (authorizedEmails.includes(user.email.toLowerCase())) {
        // Redirect using React Router to avoid hard redirects
        navigate("/lotoven/home", {replace: true});
        return;
      }
    }
  }, [user, authStatus, navigate]);

  // If user is the special user, don't render the home page at all
  if (authStatus === "authenticated" && user) {
    const authorizedEmails = ["test01@googletest.com", "test01@gmailtest.com"];
    if (authorizedEmails.includes(user.email.toLowerCase())) {
      return <div>Redirecting...</div>;
    }
  }

  // For all other users, show the regular home page
  return <HomePage />;
};

export default ProtectedHomePage;
